<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash"
                    ref="SetBtn"></buttonlist>
        <el-row style="margin-bottom:10px">
            <el-button @click="submitUpload" type="primary" plain :disabled="(SelectIndex == 5 && Car_Code == '') || (SelectIndex == 4 && Car_Code == '')">{{$t('getapi[3591]')}}<i class="el-icon-upload el-icon--right"></i>
            </el-button>
            <el-button @click="downFile" type="success" plain>{{$t('getapi[3629]')}}<i class="el-icon-download el-icon--right"></i>
            </el-button>
            <el-button @click="delFile" type="danger" plain>{{$t('getapi[3889]')}}<i class="el-icon-delete el-icon--right"></i></el-button>
            <el-button @click="reflashFile" type="info" plain>{{$t('getapi[929]')}}<i class="el-icon-refresh el-icon--right"></i>
            </el-button>
        </el-row>

        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left" style="width: 25%">
                <div class="box">
                    <el-tabs :tab-position="'top'" v-model="activeName" @tab-click="tabsHandleClick">
                        <el-tab-pane :label="$t('getapi[6875]')" name="0">
                            <el-table
                                    id="xpane-0"
                                    header-row-class-name="headerclass"
                                    stripe
                                    :data="dataDetail"
                                    v-loading="loading"
                                    :row-class-name="tableRowClassName"
                                    @row-click="editInfo"
                                    border
                                    size="mini"
                                    :highlight-current-row="true"
                                    style="width: 100%;"
                                    :height="height"
                            >
                                <el-table-column show-overflow-tooltip prop="Node_Name"
                                                 :label="$t('getapi[7869]')"></el-table-column>
                            </el-table>

                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7870]')" name="1">
                            <el-table
                                    id="xpane-1"
                                    header-row-class-name="headerclass"
                                    stripe
                                    :data="dataDetail1"
                                    v-loading="loading"
                                    @row-click="editInfo"
                                    :row-class-name="tableRowClassNameM"
                                    border
                                    size="mini"
                                    :highlight-current-row="true"
                                    style="width: 100%;"
                                    :height="height"
                            >
                                <el-table-column show-overflow-tooltip prop="Node_Name"
                                                 :label="$t('getapi[7869]')"></el-table-column>
                            </el-table>

                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7871]')" name="4">
                            <el-table
                                    id="xpane-4"
                                    header-row-class-name="headerclass"
                                    stripe
                                    :data="dataDetail4"
                                    v-loading="loading"
                                    @row-click="editInfo"
                                    :row-class-name="tableRowClassName4"
                                    border
                                    size="mini"
                                    :highlight-current-row="true"
                                    style="width: 100%;"
                                    :height="height"
                            >
                                <el-table-column show-overflow-tooltip prop="Node_Name"
                                                 :label="$t('getapi[7869]')"></el-table-column>
                            </el-table>

                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7872]')" name="5">
                            <el-table
                                    id="xpane-5"
                                    header-row-class-name="headerclass"
                                    stripe
                                    :data="dataDetail5"
                                    v-loading="loading"
                                    @row-click="editInfo"
                                    :row-class-name="tableRowClassName5"
                                    border
                                    size="mini"
                                    :highlight-current-row="true"
                                    style="width: 100%;"
                                    :height="height"
                            >
                                <el-table-column show-overflow-tooltip prop="Node_Name"
                                                 :label="$t('getapi[7869]')"></el-table-column>
                            </el-table>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>

            <li class="mid" ref="mid" style="width: 75%; margin-left: 3px">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{$t('getapi[7873]')}}</span>
                    </div>
                    <div class="box">
                        <div class="bbl" style="display:flex">
                            <span>{{$t('getapi[3590]')}}</span>
                            <el-input type="text" style="width: 330px;" size="mini"
                                      v-model="rightSelect.Node_Name"></el-input>

                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadurl"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :on-error="handleError"
                                    :on-success="handleSuccess"
                                    :file-list="fileList"
                                    :auto-upload="false"
                                    :show-file-list='false'
                                    style="margin-left: 5px"
                            >
                                <el-button slot="trigger" size="mini" type="primary"><i
                                        class="el-icon-search el-icon--left"></i>{{$t('getapi[7874]')}}
                                </el-button>
                            </el-upload>


                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[6426]')}}</span>
                            <el-input type="text" size="mini" style="width: 150px;"
                                      v-model="rightSelect.Upload_Time"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[7875]')}}</span>
                            <el-input type="text" size="mini" style="width: 150px;"
                                      v-model="rightSelect.Doc_Size"></el-input>
                            <span style="margin-left:0px">KB</span>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[6425]')}}</span>
                            <el-input type="text" size="mini" style="width: 150px;"
                                      v-model="rightSelect.Upload_Person"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[7876]')}}</span>
                            <el-input type="text" size="mini" style="width: 150px;"
                                      v-model="rightSelect.Doc_Type"></el-input>
                        </div>
                        <div class="bbl" v-if='SelectIndex==1'>
                            <span>{{$t('getapi[7877]')}}</span>
                            <el-date-picker
                                    v-model="rightSelect.Validity_Period"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    style="width: 150px;"
                                    size="mini"
                            ></el-date-picker>

                        </div>
                        <div class="bbl" v-if='SelectIndex==5 || SelectIndex==4'>
                            <span>{{$t('getapi[6206]')}}</span>
                            <el-input type="text" size="mini" style="width: 150px;"
                                      v-model="rightSelect.code" :disabled="true"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[7878]')}}</span>
                            <el-input type="textarea" size="mini" style="width: 500px;" :autosize="{ minRows: 8}"
                                      v-model="rightSelect.Doc_Detail"></el-input>
                        </div>

                    </div>

                </el-card>

            </li>
        </ul>
        <!-- 分页  -->

        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="sysdocuments" ref="ser" @getser="serclick"></serce>
    </div>

</template>
<script>
    import Common from "@/components/Common";
    import Array from "@/components/Array";
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    let curheight = window.innerHeight - 140 - 45; // 主表高度,

    export default {
        name: "doc",
        computed: {
            height(){
                return this.$windowSize.tableHeight-250
            },
            tableHeight(){
                return this.$windowSize.tableHeight-185
            },
            treeheight1(){
                return this.$windowSize.tableHeight - 250 + 'px'
            }
        },
        data() {
            return {
                canUpload: true,
                uploadurl: '',
                SelectIndex: 0,
                filename: '',
                rightSelect: {
                    Node_ID: 0,
                    Node_Name: "",
                    Upload_Time: "",
                    Upload_Person: "",
                    Doc_Type: "",
                    Doc_Size: 0,
                    Doc_Detail: "",
                    Data_Type: 0,
                    Validity_Period: null,
                    operate: "",
                    FileSrc: "",
                    code: "",
                },
                fileList: [],
                dataDetail: [],
                dataDetail1: [],
                dataDetail4: [],
                dataDetail5: [],
                dataTree: [], //根节点的树
                curNode: null,

                activeName: '0',
                fileXls: {data: null},//清单文件 value 绑定无效
                filePdf: {data: null},//Pdf文件
                userData: null, // 操作人信息

                id_tree: 0,
                defaultProps: {
                    children: "children",
                    label: "node_name",
                    node_id: "node_id",
                    isShowG: "isShowG",
                },
                defaultEexpandedkeys: [],
                loading: false, // 主表加载状态
                isact: "", //当前待编辑的节点
                isactTitle: "", //记录修改节点名称
                isUpdateGroup: false, //是否在修改模板组
                treeOType: -1, //1:新增2：编辑
                resolve_had: [],
                dg1: {
                    /*编辑对话框*/
                    visible: false,
                    doc_name: "",
                    part_list: "",
                    group_list: "",
                    doc_id: null,
                    curRow: null
                },
                Permission: {
                    P_LV2: 394,       //图纸一览
                    P_LV4_384: 384,  //右键上传
                    P_LV4_385: 385,  //右键审核
                    P_LV4_386: 386,  //右键发布
                    P_LV4_387: 387,  //右键批量

                    Node: {create: false, save: false, del: false, refresh: true, upload: false},
                    PDF: {SC: false, SH: false, FB: false, YL: true, PL: false}
                },
                nodeidflag: -1,
                routetype: 1, //1:直接打开2：跳转打开
                Car_Code: '',//car编号
                fileparm: {
                    code: '',
                    Data_Type: 0,
                    Login_Group:'',
                    Login_DB:'',
                },
                isVisible: false, //查询弹窗
                queryData: [], // 查询数组
            }
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'carview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.SelectIndex = data.Data_Type
                    vm.activeName = (data.Data_Type).toString()
                    vm.Car_Code = data.Code
                    vm.rightSelect.code = data.Code
                    vm.routetype = 2
                    vm.getView(data.Code, data.Data_Type);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch: {
            dataDetail: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataDetail1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataDetail4: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataDetail5: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
        },
        mounted: function () {
            let that = this;
            
            if(that.routetype == 1){
                that.getView('',0);
                that.Car_Code = ''
            }
            let token = JSON.parse(that.userData)['token'];
            that.$limits.dragControllerDiv();
            that.authority()
        },
        created:function(){
        this.userData = sessionStorage.getItem('userData');
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[961]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'sysdocuments');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.isVisible = false;
                that.getView('',that.SelectIndex);
            },
            handleExceed() {
                let that = this;
                that.fileList = [];
                return true;
            },
            // UploadUrl() {
            //     // let that = this;
            //     // let token = JSON.parse(that.userData).token;
            //     // if(that.SelectIndex == 5 || that.SelectIndex == 4){
            //     //     return Common.Url + '/Basic/UploadFileByDocManage?token=' + token + '&flag=1&Data_Type=' + that.SelectIndex +'&Code='+ that.rightSelect.code;
            //     // } else {
            //     //     return Common.Url + '/Basic/UploadFileByDocManage?token=' + token + '&flag=1&Data_Type=' + that.SelectIndex;
            //     // }
            //     let that = this;
            //     that.fileparm.data_type=that.SelectIndex;
            //     that.userData = sessionStorage.getItem('userData');
            //     let token = JSON.parse(that.userData).token;
            //     that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            // },
            reflashFile() {
                let that = this;
                that.getView('',that.SelectIndex);
            },
            downFile() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.rightSelect.Node_Name)) that.$message.warning('请选择文件!');

                let hrefurl = that.rightSelect.FileSrc;
                window.open(hrefurl);

            },
            delFile() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.rightSelect.Node_Name)) that.$message.warning('请选择文件!');
                that.loading = true;

                let parm = {
                    ids: that.rightSelect.Node_ID,
                    FilesSrc: that.rightSelect.FileSrc
                };
                that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));//'删除成功'
                        //that.FileList.splice(index, 1);
                        that.getView('',that.SelectIndex);
                        //清空右边
                        that.rightSelect = {};
                    }
                    that.loading = false;
                });
            },
            handleSuccess(res, file, fileList) {
                this.canUpload = false;//需要重新选
                this.$refs.upload.clearFiles();
                this.$refs.upload.fileList = [];
                let response = res.Success;
                if (response == 0) {
                    this.$message.error(res.Msg);
                } else {
                    this.getView('',this.SelectIndex);
                    //that.getDetail(0);
                    this.$message.success(res.Msg);
                }
                this.loading = false;
            },
            clearFileList() {
                let that = this;
                that.rightSelect = {};
                that.fileList = [];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.fileList = [];
                that.rightSelect.Node_Name = ''
                that.loading = false;
            },
            //点击浏览
            handleChange(file, fileList) {
                let that = this;
                //that.rightSelect.Node_Name = file.name;
                if (fileList.length > 0) {
                    this.canUpload = true;
                    this.fileList = [fileList[fileList.length - 1]];
                    this.rightSelect.Node_Name = this.fileList[0].name;
                }                
                that.userData = sessionStorage.getItem('userData');
                let token = JSON.parse(that.userData).token;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                // if(that.SelectIndex==5){
                //     that.fileparm.Data_Type=4;
                // }
                // else{
                    that.fileparm.Data_Type=that.SelectIndex;
                // }
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token+'&Login_Group='+that.fileparm.Login_Group+'&Login_DB='+that.fileparm.Login_DB+'&Data_Type='+that.fileparm.Data_Type+'&Code='+that.rightSelect.code+'';
                //console.log('--------handleChange--------');
                //console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                let that = this
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            submitUpload() {
                let that = this;
                // console.log("ceshi1");
                if ((that.$limits.fnIsEmpty(that.rightSelect.Node_Name) || that.fileList.length == 0)) {
                    that.$message.warning('请点击浏览选择文件!');
                    return;
                }
                if (this.$refs.upload.fileList.length >= 0 && this.$refs.upload.fileList[0].status == 'success') {
                    that.$message.warning('改文件已经上传,请重新选择!');
                    that.clearFileList();
                    return;
                }
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                let token = JSON.parse(that.userData).token;
                if(that.SelectIndex==5 || that.SelectIndex==4 ){
                    that.fileparm.Data_Type=that.SelectIndex;
                }
                else{
                    that.fileparm.Data_Type=that.SelectIndex;
                }
                that.uploadurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token+'&Login_Group='+that.fileparm.Login_Group+'&Login_DB='+that.fileparm.Login_DB+'&Data_Type='+that.fileparm.Data_Type+'&Code='+that.rightSelect.code+'';
                that.loading = true;
                // console.log("ceshi2:"+that.uploadurl);
                this.$refs.upload.submit();
                //this.clearFileList();

            },
            getView(code,type) {
                let that = this;
                that.loading = true;
                if(type == 4 || type == 5){
                    let pm = {
                        query_Condition: '',
                        query_field_type: '',
                        query_field_name: '',
                        row_sign: '',
                        query_sort: ''
                    };

                    let parm = {
                        Code: code,
                        Data_Type: type,
                        Param: []
                    }
                    that.queryData.forEach(item => {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    });
                    that.$http.urlpost('/Basic/FileListView', parm, function (res) {
                        if (res.Success == 1) {
                            if(type == 4){
                                that.dataDetail4 = res.DataContent.FileList
                            } else if(type == 5){
                                that.dataDetail5 = res.DataContent.FileList
                            }
                        }
                        that.loading = false;
                    });
                } else {
                    let pm = {
                        query_Condition: '',
                        query_field_type: '',
                        query_field_name: '',
                        row_sign: '',
                        query_sort: ''
                    };

                    let parm = {
                        Code: code,
                        Data_Type: type,
                        Param: []
                    }
                    that.queryData.forEach(item => {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    });
                    that.$http.urlpost('/Basic/FileListView', parm, function (res) {
                        if (res.Success == 1) {
                            if (type == 0){
                                that.dataDetail = res.DataContent.FileList
                                console.log(that.dataDetail.length)
                            } else {
                                that.dataDetail1 = res.DataContent.FileList
                            }
                            //that.authority(2);
                            //that.btnauthority()
                        }
                        that.loading = false;
                    });
                }
            },
            tabsHandleClick(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                console.log("页签名称:"+that.SelectIndex);
                // if(that.SelectIndex==5){
                //     that.fileparm.Data_Type=4;
                // }
                // else{
                    that.fileparm.Data_Type=that.SelectIndex;
                // }
                that.fileList=[];
                that.rightSelect=[];
                that.activeName = tab.name;
                if(that.SelectIndex == 4 || that.SelectIndex == 5){
                    that.getView(that.Car_Code,that.SelectIndex);
                } else {
                    that.getView('',that.SelectIndex);
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            editInfo(row) {
                let that = this
                that.getDetail(row.index);
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameM({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassName4({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassName5({row, rowIndex}) {
                row.index = rowIndex;
            },
            getDetail(rIndex) {
                let that = this;
                //let obj = {};
                if (that.SelectIndex == 0) {

                    let obj1 = that.dataDetail[rIndex];
                    var obj2 = JSON.parse(JSON.stringify(obj1))
                    that.rightSelect = obj2;

                } else if(that.SelectIndex == 1){
                    that.rightSelect = that.dataDetail1[rIndex];
                } else if(that.SelectIndex == 4){
                    that.rightSelect = that.dataDetail4[rIndex];
                } else if(that.SelectIndex == 5){
                    that.rightSelect = that.dataDetail5[rIndex];
                }

                if (!that.$limits.fnIsEmpty(that.rightSelect.Doc_Size)) {
                    that.rightSelect.Doc_Size = (that.rightSelect.Doc_Size / 1024).toFixed(4);

                }
            },
            leftt(e) {
                var left = document.getElementsByClassName("left");
                var mid = document.getElementsByClassName("mid");
                var Box = document.getElementsByClassName("Boxs");
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = "0px";
                    mid[0].style.width = bw - 10 + "px";
                } else {
                    left[0].style.width = bw - 50 + "px";
                    mid[0].style.width = "0px";
                }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getRootNode();
            },

        },
    };
</script>

<style scoped lang="less">
    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 10px;
                min-width: 70px;
                text-align: left;
                line-height: 30px;
                display: inline-block;
                margin-right: 0px;
            }
        }
    }
</style>